import React from 'react';
import ReactDOM from 'react-dom';
import './fullp.css'
import ReactFullpage from '@fullpage/react-fullpage';

import { HomeComponent } from './home'
import { AboutComponent } from './about'
import { ContactComponent } from './contact'


const fullpageOptions = {
  anchors: ["home", "about", "contact"],
  sectionsColor: ["#282c34", "#ffffff", "#303030"],
  callbacks: ["onLeave", "afterLoad"],
  scrollOverflow: false,
  slidesNavigation: true,
  responsiveSlides: true,
  licenseKey: '4CB28FDD-60B148F1-8DEF9C73-2805A5E0'
};

const FullpageWrapper = fullpageProps => (<ReactFullpage
  {...fullpageProps}
  
  render={({ state, fullpageApi }) => {
    // console.log("render prop change", state);
    
    this.aboutLoaded = false;
    
    if (state.callback === "onLeave") {
      fullpageProps.pageChangeCallback(state);
    }
    
    if (state.callback === "onLeave") {
      if(state.destination.anchor === "about"){
        this.aboutLoading = true
      } else {
        this.aboutLoading = false
      }
    }
    
    if (state.callback === "afterLoad") {
      if(state.destination.anchor === "about"){
        this.aboutLoaded = true
      } else {
        this.aboutLoaded = false
      }
    }
    
    return (
      <div>
          <HomeComponent></HomeComponent>
      		<AboutComponent aboutLoading={this.aboutLoading} aboutLoaded={this.aboutLoaded}></AboutComponent>
          <ContactComponent></ContactComponent>
      </div>
    );
  }}
/>);

export class FullPComp extends React.Component {
  
  constructor(props){
    super(props)
    this.state= {
                  aboutText: {
                      "name": "light-sync-app",
                      "version": "0.0.1",
                      "description": "Synchronise Philips Hue lights with computer display. Runs on Linux, Mac and Windows.",
                      "disclaimer": "This is an experimental hobby project. I am in no way affiliated with the Philips organization.",
                      "requirements": "Existing setup of Philips Hue Lights with a Philips Hue Bridge",
                      "dependencies": {
                        "Philips-HUE-API": "https://www.developers.meethue.com/",
                        "OpenCV-K-Means": "https://docs.opencv.org/3.0-beta/doc/py_tutorials/py_ml/py_kmeans/py_kmeans_opencv/py_kmeans_opencv.html",
                        "Python-MSS": "http://python-mss.readthedocs.io/examples.html",
                        "PHUE-Lib": "https://github.com/studioimaginaire/phue",
                        "Philips-HUE-color-converter": "https://github.com/benknight/hue-python-rgb-converter",
                        "description": "Code and theory can be found on Github",
                        "repository": "https://github.com/digital-concrete/light-sync"
                      },
                      "appDependencies": {
                        "Electron-JS": "https://electronjs.org/",
                        "Angular": "https://angular.io/",
                        "Angular-Material": "https://material.angular.io/",
                        "Pyinstaller": "https://www.pyinstaller.org/",
                        "description": "Desktop app runs an executable version of the script compiled with Pyinstaller.",
                        "repository": "https://github.com/digital-concrete/light-sync-electron"
                      },
                      "webDependencies": {
                        "React": "https://reactjs.org/",
                        "fullPage-JS": "https://alvarotrigo.com/fullPage/",
                        "Firebase": "https://firebase.google.com/",
                        "Material-Design-Lite": "https://getmdl.io/",
                        "Ace-Editor": "https://ace.c9.io/",
                        "Video": "Sequences from Enter The Void. I do not own the rights to the images included in this video. I am using them solely for creative purposes.",
                        "description": "React app using fullPage-JS and Firebase cloud functions as a backend."
                      },
                      "license" : "MIT"
                    }
                }
  }
  
  componentDidMount(){
  
    var editor = window.ace.edit("hs-editor");
    // editor.setTheme("ace/theme/github");
    editor.setTheme("ace/theme/crimson_editor");
    editor.session.setMode("ace/mode/javascript");
    editor.setOptions({
      fontSize: "13pt"
    });
    
    // editor.setValue(this.state.aboutText, -1)
    let val = JSON.stringify(this.state.aboutText, null, 4) // 4 is the indent size
    editor.session.setValue(val, -1)
    editor.gotoLine(1,0);
  }
  
  shouldComponentUpdate(nextProps, nextState){
     return false
  }
  
  handleSendClick = () => {
    console.log('this is:', this);
  }

  render() {
    return (
      <FullpageWrapper {...fullpageOptions} pageChangeCallback={this.props.pageChangeCallback}/>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/fullp.js